<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Login</h1>
      </div>
      <p class="editor-lead">Accedi con le tue credenziali per continuare.</p>
    </header>

    <form class="editor-form" [formGroup]="loginForm">
      <section class="editor-panel">
        <h2>Credenziali</h2>
        <div class="field-stack">
          <div class="field-block">
            <label for="email">Email<sup>*</sup></label>
            <input id="email" class="field" type="email" formControlName="email" autocomplete="email" #emailInput
              (input)="checkEmail()"
              [class.is-invalid]="hasError || (loginForm.get('email')?.errors && loginForm.get('email')?.dirty)">
            @if (loginForm.get('email')?.errors && loginForm.get('email')?.dirty) {
              <p class="field-error">Formato della email non corretto.</p>
            }
          </div>

          <div class="field-block">
            <label for="password">Password<sup>*</sup></label>
            <div class="password-field">
              <input id="password" class="field" [type]="pswVisibility" formControlName="password"
                autocomplete="current-password"
                [class.is-invalid]="hasError || (loginForm.get('password')?.errors && loginForm.get('password')?.dirty)">
              <button class="password-toggle" type="button" (click)="seePassword()"
                [attr.aria-label]="toggled ? 'Mostra password' : 'Nascondi password'">
                <i class="bi" [class.bi-eye]="toggled" [class.bi-eye-slash]="!toggled" aria-hidden="true"></i>
              </button>
            </div>
            @if (loginForm.get('password')?.errors && loginForm.get('password')?.dirty) {
              <p class="field-error">La password non può essere vuota.</p>
            }
          </div>
        </div>

        <div class="form-links">
          <a routerLink="/passwordDimenticata">Password dimenticata?</a>
        </div>
      </section>

      <div class="editor-actions">
        @if (hasError) {
          <p class="field-error">Email e/o password errate.</p>
        }
        <button class="editor-save" type="button" (click)="checkAccess()">Accedi</button>
      </div>
    </form>
  </div>
</div>
